import { Injectable } from "@angular/core";
import { Constants } from './app.constants';
import { AppService } from './app.service'
import { PeopleConstants } from './people/people.constants';
import { ClientConstants } from './client/client.constants';


declare var MapmyIndia;
declare var L;
declare var PruneCluster;
declare var PruneClusterForLeaflet;

@Injectable()
export class MapService {

    constructor(private appService : AppService) { }
    // debugger
    peopleText: string = this.appService.getLable(Constants.LABEL_MAP.PEOPLE);
    clientText: string = this.appService.getLable(Constants.LABEL_MAP.CLIENT);
    checkInText : string = this.appService.getLable(Constants.LABEL_MAP.CHECK_IN);
    checkOutText : string = this.appService.getLable(Constants.LABEL_MAP.CHECK_OUT);
    taskCheckInText : string =this.appService.getLable(Constants.LABEL_MAP.TASK_CHECK_IN);
    taskCheckOutText : string =this.appService.getLable(Constants.LABEL_MAP.TASK_CHECK_OUT);
    workStartText : string = this.appService.getLable(Constants.LABEL_MAP.WORK_START);
    workEndText : string =this.appService.getLable(Constants.LABEL_MAP.WORK_END);


    plotMap(containerId, options?: object, isMaxZoomLevel?: any) {
        let mapOptions;
        if (isMaxZoomLevel) {
            mapOptions = Object.assign({ center: [28.61, 77.23], zoomControl: true, hybrid: true, minZoom: isMaxZoomLevel, zoom: 4 }, options);
        } else {
            mapOptions = Object.assign({ center: [28.61, 77.23], zoomControl: true, hybrid: true, zoom: 4 }, options);
        }

        var map = new MapmyIndia.Map(containerId, mapOptions);
        return map;
    }

    setIcon(image): String {
        if (image == null || image == undefined) {
            var img = "<img  src='./assets/img/marker3.png' style='width:48px;height:48px' / >";
            var icon = L.divIcon({
                html: img,
                className: 'image-icon',
                iconSize: [48, 48]
            });
        } else {
            var img = "<img src='./assets/img/map-marker.png' style='width: 48px;height: 48px;'>";
            var icon = L.divIcon({
                html: img,
                className: 'image-icon',
                iconSize: [48, 48]
            });
        }
        return icon;
    }

    createPruneMarker(latitude: number, longitude: number) {

        let marker = new PruneCluster.Marker(latitude, longitude);
        return marker;
    }

    createPruneCluster() {
        var pruneCluster = new PruneClusterForLeaflet();
        return pruneCluster;
    }

    fitBoundsClusterOnMap(map, bounds) {
        if (bounds) {
            map.fitBounds(new L.LatLngBounds(new L.LatLng(bounds.minLat, bounds.maxLng), new L.LatLng(bounds.maxLat, bounds.minLng)));
        }
    }

    cluster(map, markers) {

        var leafletView = new PruneClusterForLeaflet();
        for (let i in markers) {
            leafletView.RegisterMarker(markers[i]);
        }
        // leafletView.RegisterMarker(marker);
        return map.addLayer(leafletView);
    }

    getNewFeatureGroup(){
        return new L.featureGroup();
    }
    update(markers) {
        for (let i of markers) {
            i.Move(i.position.lat, i.position.lng);
        }
    }


    getMarker(markerData) {
        var marker = L.marker([markerData.lat, markerData.lng], {
            icon: markerData.icon
        }
        );
        marker.on('mouseover', function (e) {
            this.setZIndexOffset(100);
            this.openPopup();
        });
        marker.on('mouseout', function (e) {
            this.closePopup();
            this.setZIndexOffset(10);
        });
        return marker;
    }

    getDivIcon(data, type ,iconType ?,entryMap ?) {
        let image = "";
        let colorClass = "";
        let text = "";
        var sequenceText ="";
     //   debugger
        if(type == PeopleConstants.PEOPLE_ACTIVITY_MAP.WORK_START){
            image = "assets/img/markerImg04.png";
            colorClass = "green";
            text = this.workStartText;
           // sequenceText = data.scount;
            if(entryMap && entryMap[data.in_timestamp] ){
                sequenceText = entryMap[data.in_timestamp];
            }
          
        }else if(type == PeopleConstants.PEOPLE_ACTIVITY_MAP.WORK_END){
            image = "assets/img/markerImg05.png";
            colorClass = "red";
            text = this.workEndText;
           // sequenceText = data.ecount;
            if(entryMap && entryMap[data.out_timestamp]){
                sequenceText = entryMap[data.out_timestamp];
            }
        }else if(type == PeopleConstants.PEOPLE_ACTIVITY_MAP.CHECK_IN){
            image = "assets/img/markerImg01.png";
            colorClass = "blue";
            text =this.checkInText;
           // sequenceText = data.scount;
            if(entryMap && entryMap[data.in_timestamp]){
                sequenceText = entryMap[data.in_timestamp];
            }
        }else if(type == PeopleConstants.PEOPLE_ACTIVITY_MAP.CHECK_OUT){
            image = "assets/img/markerImg03.png";
            colorClass = "dblue";
            text =this.checkOutText ;
           // sequenceText = data.ecount;
           if(entryMap && entryMap[data.out_timestamp]){
            sequenceText = entryMap[data.out_timestamp];
        }
        }else if(type == PeopleConstants.PEOPLE_ACTIVITY_MAP.TASK_CHECK_IN){
            image = "assets/img/markerImg06.png";
            colorClass = "lpurple";
           // sequenceText = data.scount;
            text = this.taskCheckInText;
            if(entryMap && entryMap[data.in_timestamp]){
                sequenceText = entryMap[data.in_timestamp];
            }
        }else if(type == PeopleConstants.PEOPLE_ACTIVITY_MAP.TASK_CHECK_OUT){
            image = "assets/img/markerImg07.png";
            colorClass = "dpurple";
            text =this.taskCheckOutText;
          //  sequenceText = data.ecount;
            if(entryMap && entryMap[data.out_timestamp]){
                sequenceText = entryMap[data.out_timestamp];
            }
        }else if(type == PeopleConstants.PEOPLE_ACTIVITY_MAP.CLIENT_CREATED){
            image = "assets/img/markerImg02.png";
            colorClass = "orange";
            text =this.clientText +" Created";
           // sequenceText = data.clientcount;
            if( entryMap && entryMap[data.creation_time]){
                sequenceText = entryMap[data.creation_time];
            }
        }
        else if(type == PeopleConstants.PEOPLE_ACTIVITY_MAP.ON_REQUEST){
            image = "assets/img/icon08.png";
            colorClass = "BLUE";
            text = "On Request Form";
           // sequenceText = data.ecount;
            if(entryMap && entryMap[data.creationTime]){
                sequenceText = entryMap[data.creationTime];
            }
        }else if(type == PeopleConstants.PEOPLE_ACTIVITY_MAP.STARTED_TRAVEL){
            // image = "assets/img/markerImg04.png";
            colorClass = "tgreen";
            text = this.workStartText;
           // sequenceText = data.scount;
            if(entryMap && entryMap[data.in_timestamp] ){
                sequenceText = entryMap[data.in_timestamp];
            }  
        }else if(type == PeopleConstants.PEOPLE_ACTIVITY_MAP.ENDED_TRAVEL){
            // image = "assets/img/markerImg05.png";
            colorClass = "tred";
            text = this.workEndText;
           // sequenceText = data.ecount;
            if(entryMap && entryMap[data.out_timestamp]){
                sequenceText = entryMap[data.out_timestamp];
            }
        }
        var html;
        if(iconType == 1){
             html = ' <div class="markersNew '+colorClass+' clientMarkers" >'
            + '<div class="pinDiv"><div  class="pinCircle"><span >'
            + '<img src="'+image+'" alt=""></span></div></div>'
            + '<div class="markersInfo"><h4 >'+text+'</h4></div></div>';
        }else{
            if(sequenceText == undefined || sequenceText == null){
                sequenceText = "";
            }
            html = ' <div class="markersNew '+colorClass+' clientMarkers" >'
            + '<div class="pinDiv"><div  class="pinCircle"><span >'
            + sequenceText+'</span></div></div>'
            + '</div>';
        } 


        return L.divIcon({
            className: 'my-div-icon',
            html: html,
            iconSize: [30, 50],
            iconAnchor: [10, 20],
            popupAnchor: [0, -33]
        });
    }

    createClientDivIcon(client, fromPeoplePage?) {
    //    console.log(client.categoryColorCode);
        var clientImage = client.docId;
        let customClass = "";
        if (!clientImage || clientImage == 'f407f767-616d-47f8-9aa2-99cda2d1a376' || clientImage == 'f1b4cf54-c7c6-4316-bd45-8bed27dca771') {
            clientImage = '<i class="material-icons">work</i>';
           
        } else {
            clientImage = '<img src="'+Constants.IMAGE_BASE_URL + clientImage+'" alt="">';
        }
        // clientImage = "aamarkerImg02.png";

        let color = "orange";
        if(client.categoryColorCode != undefined && client.categoryColorCode != null){
            color = ClientConstants.CLIENT_CATEGORY_COLOR_CODE[client.categoryColorCode];
        }
       
        // let html = ' <div class="markersNew orange clientMarkers ">'
        let html = ' <div class="markersNew ' +color+ ' clientMarkers ">'
        + '<div class="pinDiv"><div  class="pinCircle"><span >'
        + clientImage + '</span></div></div>'
        // + '<div class="markersInfo markersInfoName"><h4 >'+client.cust_name+'</h4><p></p></div></div>'
        + '<div class="markersInfo "><h4 >'+client.cust_name+'</h4></div></div>'

        if(fromPeoplePage){
            let markerColorCode = 12;
            if(client.categoryColorCode != undefined && client.categoryColorCode != null){
                markerColorCode = client.categoryColorCode +1;
            }
            html = `<div class="smallMarker">
            <div class="smallpinCircle"><img src="assets/img/smallMarker`+markerColorCode+`.png" alt="">
               <span class="cateIcon"><img src="assets/img/bag.png" alt=""></span>
            </div>
         </div>`
        }

        var divIcon = L.divIcon({
            iconAnchor: [17, 55],
            popupAnchor: [2, -52],
            
            html : html
        });

        return divIcon;
    }



    createClientPruneClusterDivIcon(population) {
        var divIcon = L.divIcon({
            iconAnchor: [21, 49],
            html: '<div class="clusterDiv">'
                + '<span>'+population+'</span>'
                + '</div>'
        });

        return divIcon;
    }

    createWorkplaceDivIcon(workplace) {
       // console.log(workplace.colorCode)
        let colorCode = 0;
        if(workplace.colorCode != undefined && workplace.colorCode != null){
             colorCode = workplace.colorCode + 1;
           // console.log(colorCode)
        }else{
             colorCode = 10;
        }

      
        var divIcon = L.divIcon({
            iconAnchor: [17, 55],
            popupAnchor: [2, -52],
            
            html : `<div class="smallMarker">
            <div class="smallpinCircle"><img src="assets/img/smallMarker` + (colorCode) + `.png" alt="">
               <span class="cateIcon"><img src="assets/img/building.png" alt=""></span>
            </div>
         </div>`

          });

        return divIcon;
    }

    createPeopleDivIcon(people) {
      
        var peopleImage = people.docId;
        if (peopleImage == undefined || peopleImage == null) {
            peopleImage = "resources/assests/images/default-user.png";
        } else {
            peopleImage = Constants.IMAGE_BASE_URL + peopleImage;
        }
        var rippleClass = " ";
        if(people.isSosEventFlag){
            rippleClass = " ripplecircle alarmblinker "; 
        }
        // rippleClass = " ripplecircle alarmblinker "; 
        var lastSosEventId = "";
        if(people.lastSosEventId){
            lastSosEventId = people.lastSosEventId;
        }
        var colorClass = "grey";
        if(people.last_status == "1"){
            colorClass = "green";
        }else if(people.last_status == "2"){
            colorClass = "red";
        }else if(people.last_status == "3"){
            colorClass = "blue";
        }else if(people.last_status == "4"){
            colorClass = "dblue";
        }else if(people.last_status == "5"){
            colorClass = "orange";
        }else if(people.last_status == "6"){
            colorClass = "lpurple";
        }else if(people.last_status == "7"){
            colorClass = "dpurple";
        }
        else if(people.last_status == "8"){
            colorClass = "blue";
        }
        else if(people.last_status == "11"){
            colorClass = "tgreen";
        }
        else if(people.last_status =="12"){
            colorClass = "tred";
        }else {
            colorClass = "grey";
        }
      //  if (people.movingStatus == PeopleConstants.PEOPLE_LIVE_ACTIVITY_STATUS.MOVING) {
            // statusStr = 'Moving';
        //     colorClass = "green";
        // } else if (people.movingStatus == PeopleConstants.PEOPLE_LIVE_ACTIVITY_STATUS.STOPPED) {
            // statusStr = 'Stopped'
        //     colorClass = "red";
        // } 
      
        var html = '<div class="markersNew  '+colorClass+' ">'
                + '<div class="pinDiv  ">'
                + '<div class="pinCircle '+ rippleClass+'"><span><img src="'+peopleImage+'" alt=""></span></div>'
                + '</div>'
                + '</div>';


        var divIcon = L.divIcon({
            iconAnchor: [17, 55],
            popupAnchor: [2, -52],
            
            html: html
        });

        return divIcon;
    }

    createPeopleLiveDivIcon(people) {

        // console.log(people)
        var peopleImage = people.docId;
        if (peopleImage == undefined || peopleImage == null) {
            peopleImage = "resources/assests/images/default-user.png";
        } else {
            peopleImage = Constants.IMAGE_BASE_URL + peopleImage;
        }
        var rippleClass = " ";
        if(people.isSosEventFlag){
            rippleClass = " ripplecircle alarmblinker "; 
        }
        // rippleClass = " ripplecircle alarmblinker "; 
        var lastSosEventId = "";
        if(people.lastSosEventId){
            lastSosEventId = people.lastSosEventId;
        }
        var colorClass = "grey";
       
        if(people.movingStatus == 1){
            colorClass = "green";
        }else if(people.movingStatus == 2){
            colorClass = "red";
        }
        // peopleImage = "https://workmate.mapmyindia.com/betaTest/alfresco/displayImage/ffcf17d0-1b91-49f9-a81b-cb680c65f266";

        var html = '<div class="markersNew  '+colorClass+' ">'
                + '<div class="pinDiv  ">'
                + '<div class="pinCircle '+ rippleClass+'"><span><img src="'+peopleImage+'" alt=""></span></div>'
                + '</div>'
                + '</div>';


        var divIcon = L.divIcon({
            iconAnchor: [17, 55],
            popupAnchor: [2, -52],
            
            html: html
      
        });

        return divIcon;
    }


    createPeoplePruneClusterDivIcon(population, noCluster?) {
       let  html= '<div class="clusterDiv">'
        + '<span>'+population+'</span>'
        + '</div>';

        if(noCluster){
            html = "";
        }
        var divIcon = L.divIcon({
            iconAnchor: [21, 49],
            html: html
        });

        return divIcon;
    }

    createAddressSelectMarker(markerData,markerType?){
        // var html = '<div class="markersNew  ">'
        // + '<div class="pinDiv">'
        // + '<div class="pinCircle"><span><img src="assers/img/setmarker.png" alt=""></span></div>'
        // + '</div>'
        // + '</div>';
       var markerType;
        var img ;
       
        let anchorArr = [60, 35];
        if(markerType == 1){
            img = "<img  src='assets/img/ic_marker_destination.png'/ >";
            anchorArr = [17, 45]
        }
        else{
             img = "<img  src='assets/img/setmarker.png'/ >";
            }
        
        var divIcon = L.divIcon({
            iconAnchor: anchorArr,
            popupAnchor: [2, -52],
            html : '<div>' +img+'</div>'
        });

        var marker = L.marker([markerData.lat, markerData.lng], {
            icon: divIcon
        }
        );
        // marker.on('mouseover', function (e) {
        //     this.setZIndexOffset(100);
        // });
        // marker.on('mouseout', function (e) {
        //     this.closePopup();
        //     this.setZIndexOffset(10);
        // });
        marker.setZIndexOffset(100);
        return marker;

    }

    getLatLng(lat, lng){
       return  L.latLng(lat, lng);
    }

    createTaskDivIcon(task) {

        var taskId =""
        

        if(task.id){
            taskId = task.id
        }
      
        var html = '<div class="markersNew '+task.statusClass+' clientMarkers taskmapMarkers">'
        +'<div class="pinDiv">'
        +'<div class="pinCircle"><span><img src= "'+task.statusIcon+'" alt=""></span></div>'
        +'</div>'
        +'<div class="markersInfo">'
        +' <h4>Id-'+taskId+'</h4>'                          
        +'</div>'                         
        +'</div>'
                var divIcon = L.divIcon({
                    iconAnchor: [17, 55],
                    popupAnchor: [2, -52],
                    
                    html : html
                });

        return divIcon;
    }


}